import { useContext } from "react";
import Tooltip from "../../../../../components/Tooltip/Tooltip";
import IconButton, { IconButtonThemes } from "../../../../../components/Button/IconButton";
import { Media } from "../../../../../types/scene";
import { VideoEditorContext } from "../../../../../App";
import { CopyIconV2 } from "../../../../../components/Icons/Icons";
import { ButtonWrapper } from "../navbarActions.styles";

interface Props {
  currentObject: Media;
}

const DuplicateMedia = ({ currentObject }: Props) => {
  const { handleDuplicateObject } = useContext(VideoEditorContext);

  const handleDublicate = () => {
    if (!currentObject) return;
    handleDuplicateObject(currentObject.id, { customImageDetailId: 0 });
  };

  return (
    <ButtonWrapper>
      <IconButton
        iconButtonTheme={IconButtonThemes.Transparent}
        icon={<CopyIconV2 color="white" />}
        onClick={handleDublicate}
      />
      <Tooltip
        text="Duplicate"
        position="bottom"
        style={{ boxShadow: "none", borderRadius: "4px", padding: "4px 8px 6px" }}
        reverseColor
        arrow
      />
    </ButtonWrapper>
  );
};

export default DuplicateMedia;
